import { Link } from 'react-router-dom';
import { rankings } from '@/mocks/manga';

export default function RankingSection() {
  const top10 = rankings.slice(0, 10);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-6 md:mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            漫画排行榜
          </h2>
          <span className="text-xs text-foreground-400 bg-background-200 px-2 py-1 rounded-full">TOP 10</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {top10.map((manga) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group flex items-center gap-4 p-3 md:p-4 rounded-lg bg-background-50 hover:bg-accent-50 transition-colors"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold whitespace-nowrap ${
                manga.rank === 1
                  ? 'bg-accent-500 text-white'
                  : manga.rank === 2
                  ? 'bg-accent-400 text-white'
                  : manga.rank === 3
                  ? 'bg-accent-300 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {manga.rank}
              </div>

              <div className="w-12 h-16 flex-shrink-0 rounded overflow-hidden">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors truncate">
                  {manga.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">
                  {manga.author} · {manga.tags.slice(0, 2).join(' / ')}
                </p>
              </div>

              <div className="flex items-center gap-1 text-accent-500 whitespace-nowrap">
                <i className="ri-star-fill text-sm"></i>
                <span className="text-sm font-semibold">{manga.rating}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}